"use client"

import { TagMultiSelect } from "@/components/ui/tag-multi-select"
import { mapTagSelectionFormItem } from "@/lib/utils/"
import type { Tag } from "@/types"

interface TagFieldsProps {
  /** Every tag offered in the picker. */
  availableTags: Tag[]
  /** Tags already on the post (edit form) — seeds the selected chips. */
  initialSelectedTags?: Tag[]
  /** Ids of selected existing tags. */
  tagIds: number[]
  onTagIdsChange: (ids: number[]) => void
  error?: string
}

/**
 * Tag picker for the track form: select from the system's pre-created
 * tags only. Contributors cannot create new tags from this surface.
 */
export default function TagFields({
  availableTags,
  initialSelectedTags,
  tagIds,
  onTagIdsChange,
  error,
}: TagFieldsProps) {
  return (
    <TagMultiSelect
      items={mapTagSelectionFormItem(availableTags)}
      initialSelectedItems={mapTagSelectionFormItem(initialSelectedTags ?? [])}
      onItemInserted={(id) => {
        const tagId = Number(id)
        if (Number.isNaN(tagId)) return
        onTagIdsChange([...new Set([...tagIds, tagId])])
      }}
      onItemCleared={(id) => {
        const tagId = Number(id)
        if (Number.isNaN(tagId)) return
        onTagIdsChange(tagIds.filter((existing) => existing !== tagId))
      }}
      hint={error}
    />
  )
}
